import { getMaxDate } from './getMaxDate';

export function getValidFareDate(date) {
  const DEFAULT_MAX_YEARS = 2;

  if (!date) {
    return getMaxDate(new Date(), { years: DEFAULT_MAX_YEARS });
  }

  return new Date(date);
}
